import React from "react";

const PaperBG = ({ children, className = "", fullHeight = false }) => {
  return (
   
    <div

        className={`${fullHeight ? "min-h-screen" : ""} w-full text-gray-900 ${className}`}
        style={{
        backgroundColor: "#FAF6F1",
        backgroundImage: `
          radial-gradient(#F5EFE7 1px, transparent 1px),
          radial-gradient(#E8DCCF 1px, transparent 1px)
        `,
        backgroundSize: "20px 20px",
        backgroundPosition: "0 0, 10px 10px",
        boxShadow: "inset 0 0 60px rgba(172, 142, 102, 0.05)",
      }}
    >
      {children}
    </div>
     
  );
};

export default PaperBG;

